// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3cbb6a87","453":"d4923e65","455":"20229342","977":"a11481f3"}[chunkId] + ".chunk.js";
};